/**
 * Created by Mark on 27/04/2017.
 */


class Tests{
    getSkillGraphic(type){
        if(type == "listening") return "img/admin-area/skill-listening.png";
        if(type == "reading") return "img/admin-area/skill-reading.png";
        if(type == "writing") return "img/admin-area/skill-writing.png";
        return "img/admin-area/skill-speaking.png";
    }

    getSkillTranslationGraphic(type){
        if(type == "listening") return 'ui-117';
        if(type == "reading") return 'ui-119';
        if(type == "writing") return 'ui-120';
        return 'ui-118';
    }
}

export default Tests;


// WEBPACK FOOTER //
// ./src/classes/tests.js